var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcHome(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1095_5806)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.8 1.76667C8.56921 1.59357 8.28849 1.5 8 1.5C7.71151 1.5 7.4308 1.59357 7.2 1.76667L2.53333 5.26667C2.36774 5.39086 2.23333 5.55191 2.14076 5.73705C2.04819 5.92219 2 6.12634 2 6.33333V12.6667C2 13.0203 2.14048 13.3594 2.39052 13.6095C2.64057 13.8595 2.97971 14 3.33333 14H5.93333C6.12783 14 6.31435 13.9227 6.45188 13.7852C6.58941 13.6477 6.66667 13.4612 6.66667 13.2667V10C6.66667 9.64638 6.80714 9.30724 7.05719 9.05719C7.30724 8.80714 7.64638 8.66667 8 8.66667C8.35362 8.66667 8.69276 8.80714 8.94281 9.05719C9.19286 9.30724 9.33333 9.64638 9.33333 10V13.2667C9.33333 13.4612 9.4106 13.6477 9.54812 13.7852C9.68565 13.9227 9.87218 14 10.0667 14H12.6667C13.0203 14 13.3594 13.8595 13.6095 13.6095C13.8595 13.3594 14 13.0203 14 12.6667V6.33333C14 6.12634 13.9518 5.92219 13.8592 5.73705C13.7667 5.55191 13.6323 5.39086 13.4667 5.26667L8.8 1.76667Z",
    fill: "#314450"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1095_5806"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcHome);
export default __webpack_public_path__ + "static/media/Ic_Home.9eac9bf143e8c50d5a6255e9897b1ea5.svg";
export { ForwardRef as ReactComponent };